// Module
var code = "<div class=\"widget-content\"> <wt-loading-panel is-loading=\"vm.isLoading\" message=\"vm.loadingMessage\"></wt-loading-panel> <table class=\"wide-table-combined\"> <tbody> <tr ng-repeat=\"userGroup in vm.userGroups\"> <td id=\"{{'id'+userGroup.id}}\" wt-draggable> <span>{{userGroup.name}}</span> </td> </tr> </tbody> </table> </div>";
// Exports
module.exports = code;